import React from 'react'
import clsx from 'clsx'

import { Spinner } from '@wartek-id/spinner'

import { Header as BaseHeader } from 'components/Header'
import { useScreenSizeContext } from 'utils/hooks/context/useScreenSizeContext'
import { useMaintenancePelatihanMandiri } from 'utils/hooks/useMaintenance'
import MaintenanceInfo from 'app/PelatihanMandiriPage/components/MaintenanceInfo'
import { usePelatihanMandiriDesktopDetailView } from 'app/PelatihanMandiriPage/hooks/usePelatihanMandiriDesktopDetailView'

import type { ComponentType } from 'react'

export interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  hasHeader?: boolean
  headerHasBackButton?: boolean
  headerTitle?: string
  backHref?: string
  header?: ComponentType
  enableDesktopLayout?: boolean
}

export const Layout = ({
  children,
  hasHeader = false,
  headerTitle = '',
  headerHasBackButton = false,
  className,
  header: PropHeader,
  enableDesktopLayout = false,
}: LayoutProps) => {
  const Header =
    PropHeader ??
    (() =>
      BaseHeader({ title: headerTitle, hasBackButton: headerHasBackButton }))

  const { isDesktop: isDesktopScreenSize, status } = useScreenSizeContext()
  const isDesktopDetail = usePelatihanMandiriDesktopDetailView()
  const { isOnMaintenance, isLoading } = useMaintenancePelatihanMandiri()

  const isDesktopBypass =
    enableDesktopLayout && (isDesktopScreenSize || isDesktopDetail)

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="h-full flex items-center justify-center">
          <Spinner />
        </div>
      )
    }

    return isOnMaintenance ? (
      <MaintenanceInfo />
    ) : (
      <div className="h-full">{children}</div>
    )
  }

  return (
    <div
      className={clsx(
        !isDesktopBypass && 'max-w-xl m-auto relative',
        !isDesktopBypass && hasHeader && 'mt-14',
        enableDesktopLayout && status === 'loading' && 'lg:hidden',
        isDesktopBypass && 'h-full',
        className
      )}
      style={
        !isDesktopBypass
          ? {
              height: 'calc(100vh - 3.5rem)',
            }
          : undefined
      }
    >
      {!isDesktopBypass && hasHeader && <Header />}

      {renderContent()}
    </div>
  )
}

export default Layout
